import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";
import {
  formatDuration,
  formatViews,
  getCategoryName,
  timeAgo,
} from "@/lib/video";

type Props = {
  video: Video;
  showCategory?: boolean;
};

export default function VideoCard({ video, showCategory = true }: Props) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors duration-200 hover:border-primary-300"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-secondary-200">
        <img
          src={video.cover}
          alt={`${video.title} - 日批视频短视频封面`}
          title={`${video.title} - 日批视频`}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <span className="absolute bottom-2 right-2 rounded bg-foreground-950/80 px-1.5 py-0.5 text-xs font-label text-background-50">
          {formatDuration(video.duration)}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3 md:p-4">
        <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 line-clamp-2 md:text-base">
          {video.title}
        </h3>
        <div className="mt-auto flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          {showCategory && (
            <span className="rounded-full bg-primary-100 px-2 py-0.5 font-label text-primary-700">
              {getCategoryName(video.categorySlug)}
            </span>
          )}
          <span className="flex items-center gap-1">
            <i className="ri-history-line text-sm"></i>
            {timeAgo(video.publishDate)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-sm"></i>
            {formatViews(video.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-thumb-up-line text-sm"></i>
            {formatViews(video.likes)}
          </span>
        </div>
      </div>
    </Link>
  );
}